<template>
    <nav class="header">
        <div class="header-logo">
            <img src="../assets/logo.svg" width="96px" height="96px">
        </div>
        <a class="header-name" title="Home" @click="calendar()">incs TimeTracking</a>
        <a v-if="isLoggedIn" class="header-user" style="color: white">
            {{ getUserData()?.name }}
            <svg xmlns="http://www.w3.org/2000/svg" height="1.5rem" width="1.5rem" viewBox="0 0 448 512">
                <path fill="#fff"
                    d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
            </svg>
        </a>
        <a v-if="getUserData()?.isAdmin" title="Admin" @click="admin()" :class="{ 'header-selected': viewMode === 'admin' }">Admin
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path fill="#fff"
                    d="M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" />
            </svg>
        </a>
        <a v-if="isLoggedIn" title="Calendar" @click="calendar()"
            :class="{ 'header-selected': viewMode === 'calendar' }">Kalender
            <svg xmlns="http://www.w3.org/2000/svg" height="1.5rem" width="1.5rem" viewBox="0 0 448 512">
                <path fill="#fff"
                    d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
        </a>
        <a v-if="isLoggedIn" title="Master Data" @click="masterData()"
            :class="{ 'header-selected': viewMode === 'masterdata' }">Stammdaten
            <svg xmlns="http://www.w3.org/2000/svg" height="1.5rem" width="1.5rem" viewBox="0 0 512 512">
                <path fill="#fff"
                    d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" />
            </svg>
        </a>
        <a v-if="getUserData()?.isSecretary" title="Time Viewer" @click="timeViewer()"
            :class="{ 'header-selected': viewMode === 'timeviewer' }">Time Viewer
            <svg xmlns="http://www.w3.org/2000/svg" height="1.5rem" width="1.5rem" viewBox="0 0 512 512">
                <path fill="#fff"
                    d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
            </svg>
        </a>
        <a class="header-logout" v-if="isLoggedIn" title="Logout" @click="logout()">Ausloggen
            <svg xmlns="http://www.w3.org/2000/svg" height="1.5rem" width="1.5rem" viewBox="0 0 512 512">
                <path fill="#4d4d4d"
                    d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z" />
            </svg>
        </a>
    </nav>
</template>

<script>
import { ref, inject, computed } from 'vue';
import { useRouter } from 'vue-router';
import apiService from '@/service';
import { authState } from '../authState';

export default {
    name: "HeaderComponent",
    setup() {
        const router = useRouter();
        const state = inject('authState', authState);
        const viewMode = ref('calendar');
        const isLoggedIn = computed(() => state.isLoggedIn);
        const logout = () => {
            apiService.post(`/User/Logout`);
            localStorage.clear();
            state.isLoggedIn = false;
            viewMode.value = 'calendar';
            router.push('/');
        };

        const getUserData = () => {
            var jsonString = localStorage.getItem('userData');
            return jsonString ? JSON.parse(jsonString) : null;
        };

        return { isLoggedIn, logout, getUserData, viewMode };
    },
    methods: {
        calendar() {
            this.viewMode = 'calendar';
            this.$router.push('/calendar');
        },
        masterData() {
            this.viewMode = 'masterdata';
            this.$router.push('/masterdata');
        },
        timeViewer() {
            this.viewMode = 'timeviewer';
            this.$router.push('/timeviewer');
        },
        admin() {
            this.viewMode = 'admin';
            this.$router.push('/admin');
        },
    },
};
</script>
<style>
.header {
    width: 100%;
    background-color: #4D4D4D;
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0.5rem 3rem;
    gap: 1rem;
    height: 3rem;
}

.header-logo {
    display: flex;
}

.header-name {
    margin-right: auto;
    font-size: 1.5rem;
    font-style: normal;
}

.header a {
    display: flex;
    color: white;
    align-items: center;
    gap: 0.5rem;
    padding: 0.3625rem 0.75rem;
}

.header-selected {
    cursor: pointer;
    background-color: #ffffff24;
    border-radius: 5px;
}

.header a:not(.header-user):hover {
    cursor: pointer;
    background-color: #ffffff24;
    border-radius: 5px;
}

.header a.header-logout {
    background-color: white;
    color: #4D4D4D;
    border-radius: 5px;
}

.header a.header-logout:hover {
    background-color: #c0c0c0;
}

a.header-user {
    color: #222222;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    user-select: none;
}
</style>
